<template>
  <v-container fluid class="add-page">
    <!-- Alert Banner -->
    <AAlertBanner variant="danger" :messages="alertError" title="Warning" icon="mdi-alert-outline" :icon-size="22" />

    <!-- Header Card -->
    <div class="add-header">
      <div class="add-header__top">
        <div class="add-header__info" v-if="!loadingDialog">
          <h1 class="add-header__title">{{ model.add.name }}</h1>
        </div>
        <div class="add-header__actions">
          <v-tooltip top v-if="isHrdcAdminRoles && !editMode">
            <template v-slot:activator="{ on, attrs }">
              <button
                class="hero-action-btn hero-action-btn--blue"
                v-bind="attrs"
                v-on="on"
                @click="toggleGenerateInvDialog(true)"
              >
                <v-icon size="18">mdi-invoice-list</v-icon>
              </button>
            </template>
            <span>Manual Generate HRDC Invoice</span>
          </v-tooltip>

          <v-tooltip top v-if="isTaxpodAdminRoles && !btnDisabled">
            <template v-slot:activator="{ on, attrs }">
              <button
                class="hero-action-btn hero-action-btn--green"
                v-bind="attrs"
                v-on="on"
                @click="toggleUploadManualInvDialog()"
              >
                <v-icon size="18">mdi-check-circle-outline</v-icon>
              </button>
            </template>
            <span>Submit</span>
          </v-tooltip>
        </div>
      </div>
    </div>

    <!-- Invoice Request Details Section -->
    <div class="section-card">
      <div
        class="section-header section-header--clickable"
        @click="invoicePanel = invoicePanel.includes(0) ? [] : [0]"
      >
        <v-icon color="white" small>mdi-file-document-outline</v-icon>
        <span class="section-header__title">HRDC Invoice Request</span>
        <v-spacer></v-spacer>
        <v-icon color="white" size="20">
          {{ invoicePanel.includes(0) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        </v-icon>
      </div>

      <transition name="expand">
        <div v-show="invoicePanel.includes(0)" class="section-body">
          <!-- Normal Refund Type -->
          <div v-show="applicationDetails.refundType == 1" class="invoice-details">
            <div class="invoice-details__content">
              <div class="invoice-details__badge">taxPOD Masterclass</div>

              <div class="detail-row">
                <span class="detail-label">Price</span>
                <span class="detail-val">{{ finalRequestAmount }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Event Name</span>
                <span class="detail-val">{{ invoiceRequest.programmeName }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Date (Day)</span>
                <span class="detail-val">
                  {{ formattedDateOfCourse.dateOfCourseStart }} to
                  {{ formattedDateOfCourse.dateOfCourseEnd }}
                </span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Company Name</span>
                <span class="detail-val">{{ invoiceRequest.companyName }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Grant No</span>
                <span class="detail-val">{{ invoiceRequest.grantId }}</span>
              </div>
            </div>
            <button class="copy-btn" @click="copyContent(invoiceRequest)">
              <v-icon size="18" color="var(--app-accent)">mdi-content-copy</v-icon>
              <span class="copy-btn__label">Copy</span>
            </button>
          </div>

          <!-- 70/30 Refund Type -->
          <div v-show="applicationDetails.refundType == 2">
            <v-row>
              <v-col cols="12" md="6">
                <div class="claim-card claim-card--70">
                  <div class="claim-card__header">
                    <v-icon size="18" color="var(--app-accent)" class="mr-2">mdi-percent-outline</v-icon>
                    <span class="claim-card__title">70% Claim Amount</span>
                    <v-spacer></v-spacer>
                    <button class="copy-btn copy-btn--sm" @click="copyContent(invoiceRequest)">
                      <v-icon size="16" color="var(--app-accent)">mdi-content-copy</v-icon>
                    </button>
                  </div>
                  <div class="claim-card__body">
                    <div class="invoice-details__badge">taxPOD Masterclass</div>
                    <div class="detail-row">
                      <span class="detail-label">Price</span>
                      <span class="detail-val">{{ applicationDetails.seventyPercentPrice }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">Event Name</span>
                      <span class="detail-val">{{ invoiceRequest.programmeName }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">Date (Day)</span>
                      <span class="detail-val">
                        {{ formattedDateOfCourse.dateOfCourseStart }} to
                        {{ formattedDateOfCourse.dateOfCourseEnd }}
                      </span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">Company Name</span>
                      <span class="detail-val">{{ invoiceRequest.companyName }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">Grant No</span>
                      <span class="detail-val">{{ invoiceRequest.grantId }}</span>
                    </div>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" md="6">
                <div class="claim-card claim-card--30">
                  <div class="claim-card__header">
                    <v-icon size="18" color="#8b5cf6" class="mr-2">mdi-percent-outline</v-icon>
                    <span class="claim-card__title">30% Claim Amount</span>
                    <v-spacer></v-spacer>
                    <button class="copy-btn copy-btn--sm" @click="copyContent(invoiceRequest)">
                      <v-icon size="16" color="var(--app-accent)">mdi-content-copy</v-icon>
                    </button>
                  </div>
                  <div class="claim-card__body">
                    <div class="invoice-details__badge">taxPOD Masterclass</div>
                    <div class="detail-row">
                      <span class="detail-label">Price</span>
                      <span class="detail-val">{{ applicationDetails.thirtyPercentPrice }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">Event Name</span>
                      <span class="detail-val">{{ invoiceRequest.programmeName }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">Date (Day)</span>
                      <span class="detail-val">
                        {{ formattedDateOfCourse.dateOfCourseStart }} to
                        {{ formattedDateOfCourse.dateOfCourseEnd }}
                      </span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">Company Name</span>
                      <span class="detail-val">{{ invoiceRequest.companyName }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">Grant No</span>
                      <span class="detail-val">{{ invoiceRequest.grantId }}</span>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </transition>
    </div>

    <!-- Invoice Details Form Section -->
    <div class="section-card">
      <div class="section-header">
        <v-icon color="white" small>mdi-form-textbox</v-icon>
        <span class="section-header__title">Invoice Details</span>
      </div>
      <div class="section-body">
        <div class="form-grid">
          <!-- Left Column -->
          <div class="form-column">
            <div class="form-row">
              <label class="form-row__label">HRDC Invoice File</label>
              <div class="form-row__input">
                <div
                  class="file-card"
                  :class="formData.hrdcInvoiceFileUrl ? 'file-card--has-file' : 'file-card--empty'"
                  @drop.prevent="addDropFile($event, 'hrdcInvoiceFileUrl')"
                  @dragover.prevent
                >
                  <div class="file-card__icon-wrap">
                    <div class="file-card__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__svg">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                      </svg>
                    </div>
                  </div>
                  <div class="file-card__info">
                    <span class="file-card__name">{{ formData.hrdcInvoiceFileUrl ? formData.hrdcInvoiceFileUrl.name : 'No file selected' }}</span>
                    <span class="file-card__hint">PDF only</span>
                  </div>
                  <div class="file-card__actions">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <label class="file-card__btn" v-on="on">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" /></svg>
                          <input type="file" class="file-card__hidden" accept=".pdf" @change="handleInvoiceFileChange($event, 'hrdcInvoiceFileUrl', 'hrdcInvoiceNo')" />
                        </label>
                      </template>
                      <span>Upload</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <button class="file-card__btn" v-on="on" @click="previewAttachment('hrdcInvoiceFileUrl')">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /></svg>
                        </button>
                      </template>
                      <span>Preview</span>
                    </v-tooltip>
                  </div>
                </div>
                <div v-if="errorField.hrdcInvoiceFileUrl" class="file-card__error">
                  {{ Array.isArray(errorField.hrdcInvoiceFileUrl) ? errorField.hrdcInvoiceFileUrl.join(', ') : errorField.hrdcInvoiceFileUrl }}
                </div>
              </div>
            </div>

            <div class="form-row">
              <label class="form-row__label">HRDC Invoice No.</label>
              <div class="form-row__input">
                <v-text-field
                  dense
                  filled
                  placeholder="Enter invoice number"
                  v-model="formData.hrdcInvoiceNo"
                  :error-messages="errorField.hrdcInvoiceNo"
                  class="form-input"
                  hide-details="auto"
                ></v-text-field>
              </div>
            </div>

            <div class="form-row">
              <label class="form-row__label">Client No. XERO</label>
              <div class="form-row__input">
                <v-text-field
                  dense
                  filled
                  placeholder="Enter XERO client number"
                  v-model="formData.clientNoXero"
                  :error-messages="errorField.clientNoXero"
                  class="form-input"
                  hide-details="auto"
                ></v-text-field>
              </div>
            </div>

            <div class="form-row">
              <label class="form-row__label">Invoice Date</label>
              <div class="form-row__input">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      class="rv-datepicker__trigger"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="rv-datepicker__icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                      </svg>
                      <span v-if="formData.invoiceDate" class="rv-datepicker__text">{{ formData.invoiceDate }}</span>
                      <span v-else class="rv-datepicker__placeholder">Select date...</span>
                    </div>
                  </template>
                  <v-date-picker
                    v-model="formData.invoiceDate"
                    no-title
                    scrollable
                    color="var(--app-accent)"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
          </div>

          <!-- Right Column (70/30 Case) -->
          <div class="form-column" v-show="applicationDetails.refundType == 2">
            <div class="form-row">
              <label class="form-row__label">HRDC Invoice File (30%)</label>
              <div class="form-row__input">
                <div
                  class="file-card"
                  :class="formData.hrdcInvoiceFileUrl2 ? 'file-card--has-file' : 'file-card--empty'"
                  @drop.prevent="addDropFile($event, 'hrdcInvoiceFileUrl2', 'hrdcInvoiceNo2')"
                  @dragover.prevent
                >
                  <div class="file-card__icon-wrap">
                    <div class="file-card__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__svg">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                      </svg>
                    </div>
                  </div>
                  <div class="file-card__info">
                    <span class="file-card__name">{{ formData.hrdcInvoiceFileUrl2 ? formData.hrdcInvoiceFileUrl2.name : 'No file selected' }}</span>
                    <span class="file-card__hint">PDF only</span>
                  </div>
                  <div class="file-card__actions">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <label class="file-card__btn" v-on="on">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" /></svg>
                          <input type="file" class="file-card__hidden" accept=".pdf" @change="handleInvoiceFileChange($event, 'hrdcInvoiceFileUrl2', 'hrdcInvoiceNo2')" />
                        </label>
                      </template>
                      <span>Upload</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <button class="file-card__btn" v-on="on" @click="previewAttachment('hrdcInvoiceFileUrl2')">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /></svg>
                        </button>
                      </template>
                      <span>Preview</span>
                    </v-tooltip>
                  </div>
                </div>
                <div v-if="errorField.hrdcInvoiceFileUrl2" class="file-card__error">
                  {{ Array.isArray(errorField.hrdcInvoiceFileUrl2) ? errorField.hrdcInvoiceFileUrl2.join(', ') : errorField.hrdcInvoiceFileUrl2 }}
                </div>
              </div>
            </div>

            <div class="form-row">
              <label class="form-row__label">HRDC Invoice No (30%)</label>
              <div class="form-row__input">
                <v-text-field
                  dense
                  filled
                  placeholder="Enter invoice number (30%)"
                  v-model="formData.hrdcInvoiceNo2"
                  :error-messages="errorField.hrdcInvoiceNo2"
                  class="form-input"
                  hide-details="auto"
                ></v-text-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Upload Manual Invoice Confirmation -->
    <TheModalConfirmation
      ref="uploadManualInvConfirmPopup"
      @agree="modalManualInvoice()"
    ></TheModalConfirmation>

    <!-- Generate Invoice Confirmation -->
    <TheModalConfirmation
      ref="manualGenerateInvConfirmPopup"
      @agree="agreeCallbackManualGenerateInv()"
      @disagree="disagreeCallbackManualGenerateInv()"
    ></TheModalConfirmation>

    <HrdcLoader :loadingDialog="loadingDialog"></HrdcLoader>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import Api from "@/objects/api";
import Model from "@/objects/model";
import Service from "@/objects/service";
import hrdcFunction from "@/objects/hrdcFunction";
import HrdcData from "@/services/hrdc/objects/globalData";
import TheModalConfirmation from "@/components/common/TheModalConfirmation.vue";

export default {
  mixins: [hrdcFunction],
  components: {
    TheModalConfirmation,
  },
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
    }),
    formattedDateOfCourse() {
      return {
        dateOfCourseStart: this.convertDateFormat(
          this.invoiceRequest.dateOfCourseStart
        ),
        dateOfCourseEnd: this.convertDateFormat(
          this.invoiceRequest.dateOfCourseEnd
        ),
      };
    },
    finalRequestAmount() {
      let requestAmount = this.invoiceRequest.price;
      if (this.invoiceRequest.requestManualInvoiceAmount) {
        requestAmount = this.invoiceRequest.requestManualInvoiceAmount;
      }

      return `RM ${this.formatNumber(requestAmount)}`;
    },
  },
  props: ["params"],
  data: () => ({
    apiSubmit: new Api(),
    apiCheckApplicationSubscriptionDate: new Api(),
    apiScanPdfText: new Api(),
    apiGetApplicationDetails: new Api(),
    apiGetApplicationManualInvoice: new Api(),
    apiManualGenerateHrdcInv: new Api(),
    apiGetXeroRefreshToken: new Api(),
    apiRefreshXeroToken: new Api(),
    model: new Model(),
    service: new Service(),
    hrdcData: new HrdcData(),
    alertError: [],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    passSubscriptionEndDate: true,
    loadingDialog: false,
    formData: {
      applicationNo: null,
      clientNoXero: null,
      hrdcInvoiceNo: null,
      hrdcInvoiceFileUrl: null,
      invoiceDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),

      // 70/30 case
      hrdcInvoiceFileUrl2: null,
      hrdcInvoiceNo2: null,
    },
    errorField: {
      applicationNo: null,
      clientNoXero: null,
      hrdcInvoiceNo: null,
      hrdcInvoiceFileUrl: null,
      invoiceDate: null,
      hrdcInvoiceFileUrl2: null,
      hrdcInvoiceNo2: null,
    },
    manualInvoiceDialog: false,
    invoicePanel: [0],
    invoiceRequest: {
      companyName: null,
      programmeName: null,
      price: null,
      requestManualInvoiceAmount: null,
      grantId: null,
      dateOfCourseStart: null,
      dateOfCourseEnd: null,
    },
    applicationDetails: {
      refundType: null,
      seventyPercentPrice: null,
      thirtyPercentPrice: null,
      trainingDate: null,
      rawSeventyPercentPrice: null,
      rawThirtyPercentPrice: null,
    },
    editMode: false,
    btnDisabled: false,
  }),
  async created() {
    this.loadingDialog = !this.loadingDialog;
    this.formData.applicationNo = this.$route.query._ausk;
    this.model.getByKey(this.params.modelKey);
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);

    // Assign apiDetails by mapping repository.
    const apiDetails = {
      apiSubmit: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/manual_invoice/create-manual-invoice`,
        method: "post",
      },
      apiScanPdfText: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/manual_invoice/scan-pdf`,
        method: "post",
      },
      apiGetApplicationDetails: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/application/get-application-details`,
        method: "post",
        params: {
          applicationUuid: this.formData.applicationNo,
        },
      },
      apiGetApplicationManualInvoice: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/application/get-application-manual-invoice`,
        method: "post",
        params: {
          applicationUuid: this.$route.query._ausk,
        },
      },
      apiManualGenerateHrdcInv: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/application/manual-generate-hrdc-invoice`,
        method: "post",
      },
      apiGetXeroRefreshToken: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/xero/get-xero-token?date=${moment().format(
          "YYYY-MM-DD"
        )}`,
      },
      apiRefreshXeroToken: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/xero/update-xero-token`,
        method: "put",
      },
    };

    for (const api in apiDetails) {
      if (apiDetails[api].url !== undefined) {
        this[api].setUrl(apiDetails[api].url);
      }
      if (apiDetails[api].method !== undefined) {
        this[api].setMethod(apiDetails[api].method);
      }
      if (apiDetails[api].query !== undefined) {
        this[api].setQuery(apiDetails[api].query);
      }
      if (apiDetails[api].params !== undefined) {
        this[api].setParams(apiDetails[api].params);
      }
    }

    this.apiGetApplicationDetails.setCallbackCompleted((response) => {
      try {
        // Just take first row to display basic info.
        const data = response.data[0];
        const coureSubscriptionDate = response.applicationLog.find(
          (item) =>
            item.stageId ==
            this.hrdcData.stagePriority.subscriptionDateScheduled
        );
        let cSubStartDate = null;
        let cSubEndDate = null;
        if (coureSubscriptionDate) {
          cSubStartDate = coureSubscriptionDate.startDate;
          cSubEndDate = coureSubscriptionDate.endDate;
        }

        this.invoiceRequest.companyName = data.oriCompanyName.toUpperCase();
        this.invoiceRequest.programmeName = data.programmeName;
        this.invoiceRequest.price = data.totalPrice;
        this.invoiceRequest.requestManualInvoiceAmount =
          data.requestManualInvoiceAmount;
        this.invoiceRequest.grantId = data.grantApprovalNo ?? "-";
        this.invoiceRequest.dateOfCourseStart = cSubStartDate;
        this.invoiceRequest.dateOfCourseEnd = cSubEndDate;

        // Application Details.
        this.applicationDetails.refundType = data.refundType;
        this.applicationDetails.rawSeventyPercentPrice =
          data.seventyPercentPrice;
        this.applicationDetails.rawThirtyPercentPrice = data.thirtyPercentPrice;
        this.applicationDetails.seventyPercentPrice =
          "RM " + this.formatNumber(data.seventyPercentPrice);
        this.applicationDetails.thirtyPercentPrice =
          "RM " + this.formatNumber(data.thirtyPercentPrice);

        // Application Log Details.
        const applicationLogData = response.applicationLog.find(
          (item) =>
            item.stageId ==
              this.hrdcData.stagePriority.subscriptionDateScheduled &&
            item.status == null
        );
        if (applicationLogData) {
          const trainingStartDate = this.convertDateFormat(
            applicationLogData.startDate
          );
          const trainingEndDate = this.convertDateFormat(
            applicationLogData.endDate
          );
          this.applicationDetails.trainingDate = `${trainingStartDate} to ${trainingEndDate}`;
        }

        // Get invoice date & file details.
        this.apiGetApplicationManualInvoice.fetch();
        this.apiGetApplicationManualInvoice.setCallbackCompleted((response) => {
          try {
            const { status, data } = response;
            let hrdcInvoiceFile = null;
            let hrdcInvoiceFile2 = null;
            let clientNoXero = null;
            let hrdcInvoiceNo = null;
            let hrdcInvoiceNo2 = null;
            if (status) {
              // Check form revert status must be complete in order to proceed.
              if (!data.revertFormStatus) {
                this.btnDisabled = true;
                this.alertError.push("JD14 & T3 Form is not complete!");
              }

              for (const item of data.ApplicationAttachment) {
                // Create a Blob object from the data
                const blob = new Blob([new Uint8Array(item.dataArray)]);

                // Create the File object
                const file = new File([blob], item.fileName, {
                  type: "application/pdf",
                });

                switch (item.identifier) {
                  // Normal case.
                  case "Manual Invoice":
                    hrdcInvoiceFile = file;
                    break;
                  // 70% case.
                  case 0:
                    hrdcInvoiceFile = file;
                    break;
                  // 30% case.
                  case 1:
                    hrdcInvoiceFile2 = file;
                    break;
                }
              }

              clientNoXero = data.clientNoXero;
              hrdcInvoiceNo = data.manualInvoiceToHrdc;
              hrdcInvoiceNo2 = data.manualInvoiceToHrdc2;

              if (data.ApplicationLog.length > 0) {
                this.formData.invoiceDate = moment(
                  data.ApplicationLog[0].startDate
                ).format("YYYY-MM-DD");
              }
            }

            this.formData.hrdcInvoiceFileUrl = hrdcInvoiceFile;
            this.formData.hrdcInvoiceFileUrl2 = hrdcInvoiceFile2;
            this.formData.clientNoXero = clientNoXero;
            this.formData.hrdcInvoiceNo = hrdcInvoiceNo;
            this.formData.hrdcInvoiceNo2 = hrdcInvoiceNo2;

            this.loadingDialog = !this.loadingDialog;
          } catch (err) {
            console.log(err);
          }
        });
      } catch (err) {
        console.log(err);
      }
    });
    this.apiGetApplicationDetails.fetch();

    this.stages = await this.hrdcData.allStages;
    const currentStageId =
      this.hrdcData.stageIndex[this.$store.state.hrdc.data.stageId];

    this.rolesAssignation(this.auth.roles);
    if (!this.isTaxpodAdminRoles) {
      this.alertError.push("You are not allowed to perform this action!");
      this.btnDisabled = true;
    }

    this.checkFormAlreadyFilledGte(
      currentStageId,
      this.hrdcData.stageSlug.manualInvoiceToHrdc
    );

    this.checkFormNotYetFilledLesser(
      currentStageId,
      this.hrdcData.stageSlug.clientRevertT3Form
    );
  },
  mounted() {},
  methods: {
    clearErrorMsg() {
      for (let error in this.errorField) {
        this.errorField[error] = null;
      }
    },
    showErrorMessage(response) {
      for (const key in response.data) {
        this.errorField[key] = null;
        this.errorField[key] = response.data[key];
      }
    },
    formatNumber(number) {
      if (number) {
        return number.toLocaleString();
      }
    },
    convertDateFormat(date) {
      if (date) {
        return moment(date, "YYYY-MM-DD HH:mm:ssZ").format("D MMMM YYYY");
      }

      return "-";
    },
    copyContent(item) {
      const dateOfCourse = `${this.formattedDateOfCourse.dateOfCourseStart} to ${this.formattedDateOfCourse.dateOfCourseEnd}`;
      const contentToCopy = `Event Name: ${item.programmeName}\nDate (Day): ${dateOfCourse}\nCompany Name: ${item.companyName}\nGrant No: ${item.grantId}`;

      // Create a temporary textarea element
      const textarea = document.createElement("textarea");
      textarea.value = contentToCopy;
      document.body.appendChild(textarea);

      // Select the text in the textarea
      textarea.select();
      document.execCommand("copy");

      // Remove the temporary textarea
      document.body.removeChild(textarea);

      this.$store.dispatch("showMessage", {
        message: "Copied Successfully!",
        messageType: "info",
      });
    },
    // Drag & Drop file function.
    addDropFile(e, key) {
      let file = e.dataTransfer.files[0];

      if (!file.type.match("pdf.*")) {
        this.errorField[key] = "Please select pdf file format";
        return;
      }

      this.formData[key] = file;

      switch (key) {
        case "hrdcInvoiceFileUrl":
          this.scanPdf(true, key, "hrdcInvoiceNo");
          break;

        case "hrdcInvoiceFileUrl2":
          this.scanPdf(true, key, "hrdcInvoiceNo2");
          break;

        default:
          break;
      }
    },
    scanPdf($event, type, invoiceType) {
      if ($event) {
        this.loadingDialog = !this.loadingDialog;
        const fd = new FormData();
        fd.append("hrdcInvoiceFileUrl", this.formData[type]);

        this.apiScanPdfText.setParams(fd);
        this.apiScanPdfText.fetch();
        this.apiScanPdfText.setCallbackCompleted((response) => {
          try {
            if (response.status) {
              this.formData[invoiceType] = response.data.invoice;
              this.formData.clientNoXero = response.data.clientNo;

              const parsedDate = moment(
                response.data.invoiceDate,
                "DD MMMM YYYY"
              );
              const formattedDate = parsedDate.format("YYYY-MM-DD");
              this.formData.invoiceDate = formattedDate;
            } else {
              this.$store.dispatch("showMessage", {
                message: response.data,
                messageType: "error",
                timeout: 2000,
              });
            }

            this.loadingDialog = !this.loadingDialog;
          } catch (err) {
            console.log(err);
          }
        });
      }
    },
    previewAttachment(fileKey) {
      const file = this.formData[fileKey];
      if (file) {
        const url = URL.createObjectURL(file);
        window.open(url, '_blank');
      }
    },
    handleInvoiceFileChange($event, fileKey, invoiceKey) {
      const file = $event.target.files[0];
      if (file) {
        this.formData[fileKey] = file;
        this.scanPdf(true, fileKey, invoiceKey);
      }
    },
    //EOC
    modalManualInvoice() {
      this.manualInvoiceDialog = !this.manualInvoiceDialog;
      this.submit();
    },
    redirectBack() {
      let route = "HrdcApplication";
      if (this.params.backTo) {
        route = this.params.backTo;
      }

      this.$store.commit("assignDeveloperData", {
        paginationPageNo: this.$route.query.currentPageNo,
      });

      this.$router.push({
        name: route,
        params: {
          modelKey: this.model.key,
          backTo: "",
        },
        query: {
          viewId: this.$store.state.hrdc.data.viewId,
          _ausk: this.$route.query._ausk,
        },
      });
    },
    toggleUploadManualInvDialog() {
      this.$refs.uploadManualInvConfirmPopup.open({
        title: "Manual Invoice to HRDC",
        message: "Please confirm that you wish to submit this Manual Invoice.",
        options: {
          btnDisagree: "Cancel",
          btnAgree: "Submit",
        },
        agree: () => {
          this.modalManualInvoice();
        },
        disagree: () => {},
      });
    },
    toggleGenerateInvDialog(val) {
      if (val) {
        this.$refs.manualGenerateInvConfirmPopup.open({
          title: "Manual Generate HRDC Invoice",
          message: "Are you confirm to generate HRDC Invoice?",
          options: {
            btnDisagree: "Cancel",
            btnAgree: "Generate",
          },
          agree: () => {
            this.agreeCallbackManualGenerateInv();
          },
          disagree: () => {
            this.disagreeCallbackManualGenerateInv();
          },
        });
      }
    },
    agreeCallbackManualGenerateInv() {
      this.showLoadingDialog();

      this.apiGetXeroRefreshToken.setCallbackCompleted(async (xeroTokenRes) => {
        try {
          if (!xeroTokenRes || !xeroTokenRes.status) {
            throw new Error(
              "Unable to generate HRDC Invoice due to XERO invalid response, please contact administrator for assistance (1)"
            );
          }

          // Check got valid refresh token or not, if yes, can direct call XERO API.
          if (xeroTokenRes.data) {
            const refreshToken = xeroTokenRes.data.token;

            const token = await this.xeroRequestAccessToken(
              `${
                this.$service[this.service.key]
              }/v1/en/console/xero/request-xero-access-token`,
              this.$store.state.auth.data.token,
              refreshToken
            );

            const accessToken = token.data.access_token;

            // Refresh the new refresh token in db.
            this.apiRefreshXeroToken.setParams({
              refresh_token: token.data.refresh_token,
              token_id: xeroTokenRes.data.id,
            });
            this.apiRefreshXeroToken.fetch();

            const connectionResponse = await this.xeroRequestTenantId({
              url: `${
                this.$service[this.service.key]
              }/v1/en/console/xero/get-xero-tenant-id`,
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.data.token}`,
              },
              postData: {
                accessToken,
              },
            });

            if (!connectionResponse || !connectionResponse.status) {
              throw new Error(
                "Unable to generate HRDC Invoice due to XERO invalid response, please contact administrator for assistance (2)"
              );
            }

            const connectionData = connectionResponse.data;
            const connection = connectionData[connectionData.length - 1];
            const tenantId = connection.tenantId;

            // const [TrackingCategoryResponse] = await Promise.all([
            //   // Get tracking categories.
            //   this.xeroCallApi({
            //     authorization: this.$store.state.auth.data.token,
            //     service_key: this.model.serviceKey,
            //     access_token: accessToken,
            //     xero_tenant_id: tenantId,
            //     api_type: "get_tracking_categories",
            //     method: "get",
            //     postData: null,
            //     tracking_category_name: "taxPOD",
            //   }),
            // ]);

            const ContactID = process.env.VUE_APP_XERO_HRDC_CONTACT_ID;
            const Code = process.env.VUE_APP_XERO_HRDC_ACCOUNT_CODE;
            const TaxType = process.env.VUE_APP_XERO_HRDC_ACCOUNT_TAX_TYPE;

            const TaxRateResponse = await this.xeroCallApi({
              authorization: this.$store.state.auth.data.token,
              service_key: this.model.serviceKey,
              access_token: accessToken,
              xero_tenant_id: tenantId,
              api_type: "get_tax_rates",
              method: "get",
              postData: null,
              url_suffix: `${TaxType}`,
            });

            const [taxRate] = TaxRateResponse.data.TaxRates.map(
              (item) => item.EffectiveRate
            );

            // Start to do looping based on refund type (normal/70+30)
            const LineItems = [];
            let xeroProcessCount = 0;
            const descriptionData = {
              programmeName: this.invoiceRequest.programmeName,
              trainingDate: this.applicationDetails.trainingDate,
              companyName: this.invoiceRequest.companyName,
              grantApprovalNo: this.invoiceRequest.grantId,
              note: null,
            };

            if (this.applicationDetails.refundType == 1) {
              const {
                unitAmount: requestInvoiceUnitAmount,
                taxAmount: requestInvoiceTaxAmount,
              } = this.calculateLineAmounts(
                this.invoiceRequest.requestManualInvoiceAmount,
                taxRate
              );

              // Normal Claim
              LineItems.push({
                Description: this.generateHrdcInvoiceDesc(descriptionData),
                Quantity: 1,
                LineAmount: requestInvoiceUnitAmount,
                TaxType,
                AccountCode: Code,
                TaxAmount: requestInvoiceTaxAmount,
                Tracking: [
                  { Name: "Division", Option: "taxPOD" },
                  { Name: "MyInvois Classification", Option: "022 - Others" },
                ],
              });
            }

            if (this.applicationDetails.refundType == 2) {
              // 70+30 Claim
              const {
                unitAmount: requestInvoice70UnitAmount,
                taxAmount: requestInvoice70TaxAmount,
              } = this.calculateLineAmounts(
                this.applicationDetails.rawSeventyPercentPrice,
                taxRate
              );
              const {
                unitAmount: requestInvoice30UnitAmount,
                taxAmount: requestInvoice30TaxAmount,
              } = this.calculateLineAmounts(
                this.applicationDetails.rawThirtyPercentPrice,
                taxRate
              );

              const additionalNote30 = `RM ${this.applicationDetails.rawThirtyPercentPrice} - 30 % Upfront Payment`;
              descriptionData.note = additionalNote30;
              const Description30 =
                this.generateHrdcInvoiceDesc(descriptionData);

              descriptionData.note = `${additionalNote30}, RM ${this.applicationDetails.rawSeventyPercentPrice} - 70% Payment Upon Claim Approval.`;
              const Description70 =
                this.generateHrdcInvoiceDesc(descriptionData);

              LineItems.push(
                // 70%
                {
                  Description: Description70,
                  Quantity: 1,
                  LineAmount: requestInvoice70UnitAmount,
                  TaxType,
                  AccountCode: Code,
                  TaxAmount: requestInvoice70TaxAmount,
                  Tracking: [
                    { Name: "Division", Option: "taxPOD" },
                    { Name: "MyInvois Classification", Option: "022 - Others" },
                  ],
                },
                // 30%
                {
                  Description: Description30,
                  Quantity: 1,
                  LineAmount: requestInvoice30UnitAmount,
                  TaxType,
                  AccountCode: Code,
                  TaxAmount: requestInvoice30TaxAmount,
                  Tracking: [
                    { Name: "Division", Option: "taxPOD" },
                    { Name: "MyInvois Classification", Option: "022 - Others" },
                  ],
                }
              );
            }

            for (const LineItem of LineItems) {
              // Construct data needed to request api to XERO.
              const invoicePostData = {
                Invoices: [
                  {
                    Type: this.INVOICE_TYPE,
                    Contact: {
                      ContactID,
                    },
                    LineItems: [LineItem],
                    Status: this.getInvoiceStatus(),
                    DueDate: moment().format("YYYY-MM-DD"),
                  },
                ],
              };

              // Call XERO generate invoice api.
              const generateInvoiceRes = await this.xeroCallApi({
                authorization: this.$store.state.auth.data.token,
                service_key: this.model.serviceKey,
                access_token: accessToken,
                xero_tenant_id: tenantId,
                api_type: "post_invoices",
                method: "post",
                postData: invoicePostData,
              });
              const generateInvoiceResData = generateInvoiceRes.data;

              if (
                !generateInvoiceRes ||
                generateInvoiceRes.status !== 200 ||
                generateInvoiceResData.Status !== "OK"
              ) {
                throw new Error(
                  "HRDC Invoice created, but failed to upload invoice to system, please contact administrator for assistance"
                );
              }

              // Construct GET HRDC Invoice attachments data.
              const invoiceDetails = generateInvoiceResData.Invoices.map(
                (item) => {
                  return {
                    InvoiceID: item.InvoiceID, // A xero unique Invoice uuid
                    InvoiceNumber: item.InvoiceNumber, // e.g. YGC-XXXXXX
                    InvoiceDate: item.DueDateString,
                  };
                }
              );

              // Call XERO GET Invoice via pdf api. (XERO API return PDF as pdf binary string type).
              const hrdcInvoiceAtchRes = await this.xeroCallApi({
                authorization: this.$store.state.auth.data.token,
                service_key: this.model.serviceKey,
                access_token: accessToken,
                xero_tenant_id: tenantId,
                api_type: "get_invoices",
                method: "get",
                postData: null,
                url_suffix: `${invoiceDetails[0].InvoiceID}`,
                accept_header: "application/pdf",
                config: {
                  responseType: "arraybuffer", // Response received will be an PDF type of array buffer.
                  responseEncoding: "binary", // Response encoding using binary.
                },
              });

              // Construct data to store in azure blob storage.
              const arrayBuffer = hrdcInvoiceAtchRes.data;
              const blob = new Blob([arrayBuffer], {
                type: "application/pdf",
              });
              const file = new File([blob], "hrdc_invoice.pdf", {
                type: "application/pdf",
              });

              const fd = new FormData();
              fd.append("invoice", file);
              fd.append("xeroProcessCount", xeroProcessCount);
              fd.append("refundType", this.applicationDetails.refundType);
              fd.append("applicationUuid", this.formData.applicationNo);
              fd.append("referById", this.auth.uuid);
              fd.append("hrdcInvoiceNo", invoiceDetails[0].InvoiceNumber);
              fd.append("invoiceDate", invoiceDetails[0].InvoiceDate);
              fd.append("clientNoXero", this.HRDC_CLIENT_NO);
              fd.append(
                "updateToStageId",
                this.hrdcData.stagePriority.manualInvoiceToHrdc
              );
              fd.append(
                "updateToStageName",
                this.hrdcData.stageSlugToStageName.manualInvoiceToHrdc
              );
              fd.append(
                "invoiceDateScheduled",
                this.hrdcData.stagePriority.invoiceDateScheduled
              );

              // Store the HRDC Invoice PDF binary data to azure blob storage & update log.
              await this.$axios
                .post(
                  `${
                    this.$service[this.service.key]
                  }/v1/en/console/manual_invoice/process-hrdc-flow`,
                  fd,
                  {
                    headers: {
                      Authorization: `Bearer ${this.$store.state.auth.data.token}`,
                    },
                  }
                )
                .then((response) => {
                  try {
                    const { status, data } = response.data;
                    if (status) {
                      xeroProcessCount++;

                      if (xeroProcessCount == LineItems.length) {
                        this.successRedirect(data);
                      }
                    }
                  } catch (err) {
                    console.log(err);
                  }
                });
            }
          } else {
            // Else, need to autorize app and get a new refresh token.
            const xeroParams = {
              redirectCallbackUri: this.xeroRedirectUri,
              stateType: this.$route.query._ausk,
            };
            const childWindow = window.open(
              this.requestAuthorizeApp(xeroParams)
            );
            var timer = setInterval(() => {
              if (childWindow.closed) {
                this.successRedirect("HRDC Invoice Generated Successfully!");
                clearInterval(timer);
              }
            }, 500);
          }
        } catch (err) {
          console.log(err);
          this.alertError.push(
            "Failed to generate HRDC Invoice due to invalid credentials & this form is submitted, please contact admin for support!"
          );
          return false;
        } finally {
          this.hideLoadingDialog();
        }
      });
      this.apiGetXeroRefreshToken.fetch();
    },
    disagreeCallbackManualGenerateInv() {
      //
    },
    successRedirect(data) {
      this.$store.commit("assignDeveloperData", {
        paginationPageNo: this.$route.query.currentPageNo,
      });

      this.$router.push({
        name: "ViewHrdcApplication",
        query: {
          viewId: this.$store.state[this.service.key].data.viewId,
          _ausk: this.$route.query._ausk,
        },
      });
      this.$store.dispatch("showMessage", {
        message: data,
        messageType: "success",
        timeout: 2000,
      });
    },
    async submit() {
      this.loadingDialog = !this.loadingDialog;
      // Generate Form Data to handle multipart/form-data
      const fd = new FormData();
      fd.append("applicationUuid", this.formData.applicationNo);
      fd.append("clientNoXero", this.formData.clientNoXero);
      fd.append("hrdcInvoiceNo", this.formData.hrdcInvoiceNo);
      fd.append("hrdcInvoiceFileUrl", this.formData.hrdcInvoiceFileUrl);
      fd.append("hrdcInvoiceNo2", this.formData.hrdcInvoiceNo2);
      fd.append("hrdcInvoiceFileUrl2", this.formData.hrdcInvoiceFileUrl2);
      fd.append("refundType", this.applicationDetails.refundType);
      fd.append("invoiceDate", this.formData.invoiceDate);
      fd.append("referById", this.auth.uuid);
      fd.append("editMode", this.editMode);

      this.apiSubmit.setParams(fd);
      this.apiSubmit.fetch();
      this.apiSubmit.setCallbackCompleted((response) => {
        try {
          this.clearErrorMsg();
          this.loadingDialog = !this.loadingDialog;
          if (!response.status) {
            this.showErrorMessage(response);
            if (response.applicationNotFound) {
              this.$store.dispatch("showMessage", {
                message: response.data.applicationNo,
                messageType: "error",
                timeout: 2000,
              });
            }
          }
          if (response.status) {
            this.$store.commit("assignDeveloperData", {
              paginationPageNo: this.$route.query.currentPageNo,
            });

            this.$router.push({
              name: "HrdcApplication",
              query: {
                viewId: this.$store.state.hrdc.data.viewId,
              },
            });
            this.$store.dispatch("showMessage", {
              message: response.data,
              messageType: "success",
              timeout: 2000,
            });
          }
        } catch (err) {
          console.log(err);
        }
      });
    },
  },
};
</script>
<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .add-page {
  background-color: var(--app-page);
}

.dark-mode .add-header {
  background: var(--app-elevated);
}

.dark-mode .back-btn {
  background: var(--app-form-tile);
  border: 1px solid var(--app-border-strong);
}

.dark-mode .back-btn:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-border-strong);
}

.dark-mode .hero-action-btn {
  background: var(--app-form-tile);
  color: var(--app-text-muted);
}

.dark-mode .hero-action-btn:hover {
  background: var(--app-form-tile-hover);
  color: var(--app-text);
}

.dark-mode .hero-action-btn--blue {
  background: var(--app-accent-soft);
}

.dark-mode .hero-action-btn--green {
  background: var(--app-form-tile);
  color: var(--app-text);
}

.dark-mode .hero-action-btn--green:hover {
  background: var(--app-form-tile-hover);
  color: var(--app-text);
}

.dark-mode .hero-action-btn--green .v-icon {
  color: var(--app-text) !important;
}

.dark-mode .section-card {
  background: var(--app-elevated);
}

.dark-mode .section-body {
  background: var(--app-card);
}

.dark-mode .invoice-details__badge {
  background: var(--app-accent-soft);
}

.dark-mode .detail-val {
  border: 1px solid var(--app-border);
}

.dark-mode .copy-btn {
  background: var(--app-accent-soft);
}

.dark-mode .copy-btn:hover {
  background: var(--app-accent-soft);
}

.dark-mode .claim-card {
  border: 1px solid var(--app-border);
}

.dark-mode .claim-card__header {
  border-bottom: 1px solid var(--app-border);
}

.dark-mode .claim-card--70 .claim-card__header {
  background: var(--app-accent-soft);
}

.dark-mode .claim-card--30 .claim-card__header {
  background: var(--app-purple-bg);
}

.dark-mode .claim-card__title {
  color: var(--app-text);
}

.dark-mode .claim-card__body {
  background: var(--app-card);
}

.dark-mode .form-input >>> .v-input__slot {
  background: var(--app-field) !important;
  border: 1px solid var(--app-field-border) !important;
}

.dark-mode .form-input >>> .v-text-field__slot input::placeholder {
  color: var(--app-field-placeholder) !important;
}

.dark-mode .file-card {
  background: var(--app-form-tile);
  border: 1px solid var(--app-border);
}

.dark-mode .file-card:hover {
  background: var(--app-form-tile-hover);
}

.dark-mode .file-card__icon-wrap::after {
  border: 2px solid var(--app-card);
}

.dark-mode .file-card--has-file .file-card__icon-wrap::after {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width='3' stroke='var(--app-card)'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='m4.5 12.75 6 6 9-13.5'/%3E%3C/svg%3E");
}

.dark-mode .file-card--empty .file-card__icon-wrap::after {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width='3' stroke='var(--app-card)'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M6 18 18 6M6 6l12 12'/%3E%3C/svg%3E");
}

.dark-mode .file-card__name {
  color: var(--app-text);
}

.dark-mode .file-card__hint {
  color: var(--app-text-faint);
}

.dark-mode .file-card__btn {
  background: var(--app-form-tile);
  color: var(--app-text-muted);
}

.dark-mode .file-card__btn:hover {
  background: var(--app-form-tile-hover);
  color: var(--app-text);
}

.dark-mode .rv-datepicker__trigger {
  border: 1px solid var(--app-field-border);
  background: var(--app-field);
}

.dark-mode .rv-datepicker__trigger:hover {
  border-color: var(--app-field-border-hover);
}

.dark-mode .rv-datepicker__icon {
  color: var(--app-text-faint);
}

.dark-mode .rv-datepicker__text {
  color: var(--app-text);
}

.dark-mode .rv-datepicker__placeholder {
  color: var(--app-text-faint);
}

/* >>> end auto-dark <<< */

/* ============================================
   PAGE WRAPPER
   ============================================ */
.add-page {
  background-color: #d8dce2;
  /* Fills main minus the breadcrumb and footer; a `100vh - 64px` guess only
     subtracts the app bar and overflows. See .layout-main__content. */
  flex: 1 0 auto;
  padding-top: 24px !important;
  padding-bottom: 60px !important;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* ============================================
   HEADER
   ============================================ */
.add-header {
  background: #eaecef;
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  margin-bottom: 24px;
  overflow: hidden;
}

.add-header__top {
  display: flex;
  align-items: center;
  padding: 24px 28px;
}

.back-btn {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #d1d5db;
  cursor: pointer;
  margin-right: 16px;
  transition: all 0.2s ease;
}

.back-btn:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.add-header__info {
  flex: 1;
  min-width: 0;
}

.add-header__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #3a3f47;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  letter-spacing: -0.2px;
}

.add-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

/* ============================================
   ACTION BUTTONS
   ============================================ */
.hero-action-btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: none;
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  font-family: 'Lato', sans-serif;
}

.hero-action-btn:hover {
  background: #e2e8f0;
  color: #334155;
  transform: translateY(-1px);
}

.hero-action-btn--blue {
  background: #dbeafe;
  color: #1d4ed8;
}

.hero-action-btn--blue:hover {
  background: #bfdbfe;
  color: #1e40af;
}

.hero-action-btn--green {
  background: #dcfce7;
  color: #16a34a;
}

.hero-action-btn--green:hover {
  background: #d1fae5;
  color: #059669;
}

/* ============================================
   SECTION CARDS
   ============================================ */
.section-card {
  background: #eaecef;
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
  margin-bottom: 24px;
}

.section-card:hover {
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06);
}

.section-header {
  background: linear-gradient(135deg, #0ea5e9, #38bdf8);
  padding: 13px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-header--clickable {
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.section-header--clickable:hover {
  opacity: 0.92;
}

.section-header__title {
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.section-body {
  padding: 22px;
  background: #fff;
}

/* ============================================
   INVOICE DETAILS (Normal)
   ============================================ */
.invoice-details {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.invoice-details__content {
  flex: 1;
}

.invoice-details__badge {
  display: inline-block;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 0.78rem;
  font-weight: 700;
  padding: 5px 14px;
  border-radius: 8px;
  margin-bottom: 16px;
  letter-spacing: 0.5px;
}

/* ============================================
   DETAIL ROWS
   ============================================ */
.detail-row {
  display: flex;
  align-items: center;
  padding: 5px 0;
}

.detail-label {
  flex: 0 0 150px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #2d3239;
  line-height: 1.6;
}

.detail-val {
  flex: 1;
  font-size: 0.85rem;
  color: #1a1e24;
  line-height: 1.5;
  word-break: break-word;
  display: inline-flex;
  align-items: center;
  font-weight: 600;
  background: #f1f3f5;
  border: 1px solid #e2e4e8;
  border-radius: 8px;
  padding: 7px 14px;
  transition: all 0.15s ease;
}

.detail-val:hover {
  background: #eef1f5;
  border-color: #c9cdd3;
}

/* ============================================
   COPY BUTTON
   ============================================ */
.copy-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 10px;
  border: 1.5px solid #e0f2fe;
  background: #f0f9ff;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.copy-btn:hover {
  background: #e0f2fe;
  border-color: #7dd3fc;
}

.copy-btn__label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #0ea5e9;
}

.copy-btn--sm {
  padding: 5px 10px;
}

/* ============================================
   CLAIM CARDS (70/30)
   ============================================ */
.claim-card {
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}

.claim-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}

.claim-card__header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
}

.claim-card--70 .claim-card__header {
  background: #f0f9ff;
}

.claim-card--30 .claim-card__header {
  background: #f5f3ff;
}

.claim-card__title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: 0.3px;
}

.claim-card__body {
  padding: 16px;
  background: #fff;
}

.claim-card__body .detail-label {
  flex: 0 0 120px;
  font-size: 0.75rem;
}

.claim-card__body .detail-val {
  font-size: 0.8rem;
  padding: 5px 10px;
}

/* ============================================
   FORM SECTION
   ============================================ */
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
}

.form-column {
  padding: 0 4px;
}

.form-column:first-child {
  border-right: 1px solid #eceef1;
  padding-right: 24px;
}

.form-column:last-child {
  padding-left: 24px;
}

.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}

.form-row__label {
  flex: 0 0 160px;
  font-size: 0.8rem;
  font-weight: 700;
  color: #2d3239;
  line-height: 1.6;
  padding-right: 16px;
}

.form-row__input {
  flex: 1;
  min-width: 0;
}

.form-input >>> .v-input__slot {
  background: #ffffff !important;
  border: 1px solid #e2e4e8 !important;
  border-radius: 8px !important;
  min-height: 40px !important;
  transition: all 0.15s ease;
}

.form-input >>> .v-input__slot:hover {
  border-color: #c9cdd3 !important;
}

.form-input >>> .v-input--is-focused .v-input__slot,
.form-input.v-input--is-focused >>> .v-input__slot {
  border-color: #0ea5e9 !important;
}

.form-input >>> .v-text-field__slot input,
.form-input >>> .v-text-field__slot input::placeholder {
  font-size: 0.85rem;
  font-weight: 600;
}

.form-input >>> .v-text-field__slot input::placeholder {
  color: #94a3b8 !important;
  font-weight: 500;
}

.form-input >>> .v-input__slot::before,
.form-input >>> .v-input__slot::after {
  display: none !important;
}

/* ============================================
   FILE CARD
   ============================================ */
.file-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #e2e4e8;
  transition: background 0.15s;
}

.file-card:hover {
  background: #f1f5f9;
}

.file-card__icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #f1e5e5;
  color: #ef4444;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.file-card__icon-wrap {
  position: relative;
  flex-shrink: 0;
}

.file-card__icon-wrap::after {
  content: '';
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid white;
  background-repeat: no-repeat;
}

.file-card--has-file .file-card__icon-wrap::after {
  background-color: #22c55e;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width='3' stroke='white'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='m4.5 12.75 6 6 9-13.5'/%3E%3C/svg%3E");
}

.file-card--empty .file-card__icon-wrap::after {
  background-color: #ef4444;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width='3' stroke='white'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M6 18 18 6M6 6l12 12'/%3E%3C/svg%3E");
}

.file-card__svg {
  width: 20px;
  height: 20px;
}

.file-card__info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.file-card__name {
  font-size: 0.82rem;
  font-weight: 500;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-card__hint {
  font-size: 0.7rem;
  color: #94a3b8;
}

.file-card__actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.file-card__btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: none;
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.file-card__btn:hover {
  background: #e2e8f0;
  color: #334155;
}

.file-card__btn-icon {
  width: 16px;
  height: 16px;
}

.file-card__hidden {
  display: none;
}

.file-card__error {
  color: #dc2626;
  font-size: 0.75rem;
  margin-top: 4px;
  padding-left: 4px;
}

/* ============================================
   DATEPICKER
   ============================================ */
.rv-datepicker__trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 42px;
  padding: 6px 12px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
}

.rv-datepicker__trigger:hover {
  border-color: #94a3b8;
}

.rv-datepicker__trigger--error {
  border-color: #ef4444;
}

.rv-datepicker__icon {
  width: 18px;
  height: 18px;
  color: #94a3b8;
  flex-shrink: 0;
}

.rv-datepicker__text {
  color: #1e293b;
  font-weight: 600;
}

.rv-datepicker__placeholder {
  color: #94a3b8;
}

/* ============================================
   TRANSITIONS
   ============================================ */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.expand-enter,
.expand-leave-to {
  opacity: 0;
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
}

/* ============================================
   RESPONSIVE
   ============================================ */
@media (max-width: 959px) {
  .add-header__top {
    padding: 16px 20px;
  }

  .add-header__actions {
    flex-direction: row;
    gap: 4px;
  }

  .hero-action-btn {
    width: 36px;
    height: 36px;
  }

  .section-body {
    padding: 16px;
  }

  .detail-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .detail-label {
    flex: none;
  }

  .detail-val {
    width: 100%;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .form-column:first-child {
    border-right: none;
    border-bottom: 1px solid #eceef1;
    padding-right: 4px;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }

  .form-column:last-child {
    padding-left: 4px;
  }

  .form-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .form-row__label {
    flex: none;
    padding-right: 0;
  }

  .form-row__input {
    width: 100%;
  }

  .claim-card__body .detail-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .claim-card__body .detail-label {
    flex: none;
  }

  .claim-card__body .detail-val {
    width: 100%;
  }
}

/* ============================================
   DARK MODE
   ============================================ */
.dark-mode .add-page { background-color: var(--app-page); }
.dark-mode .add-header { background: var(--app-card); }
.dark-mode .add-header__title { color: var(--app-text); }
.dark-mode .back-btn { background: var(--app-form-tile); border-color: var(--app-form-tile-border); }
.dark-mode .back-btn:hover { background: var(--app-form-tile-hover); }
.dark-mode .section-card { background: var(--app-card); }
.dark-mode .section-body { background: var(--app-card); }
.dark-mode .detail-label { color: var(--app-text-muted); }
.dark-mode .detail-val { background: var(--app-form-tile); border-color: var(--app-form-tile-border); color: var(--app-text); }
.dark-mode .detail-val:hover { background: var(--app-border); border-color: var(--app-border-strong); }
.dark-mode .invoice-details__badge { background: var(--app-accent-soft); color: var(--app-accent); }
.dark-mode .claim-card { border-color: var(--app-border); }
.dark-mode .claim-card__header { border-color: var(--app-border); }
.dark-mode .claim-card--70 .claim-card__header { background: var(--app-accent-soft); }
.dark-mode .claim-card--30 .claim-card__header { background: var(--app-purple-bg); }
.dark-mode .claim-card__title { color: var(--app-text); }
.dark-mode .claim-card__body { background: var(--app-card); }
.dark-mode .form-row__label { color: var(--app-text-muted); }
.dark-mode .form-input >>> .v-input__slot { background: var(--app-field) !important; border-color: var(--app-field-border) !important; }
.dark-mode .form-input >>> .v-text-field__slot input { color: var(--app-text) !important; }
.dark-mode .file-card { background: var(--app-form-tile); border-color: var(--app-form-tile-border); }
.dark-mode .file-card__name { color: var(--app-text); }
.dark-mode .file-card__hint { color: var(--app-text-faint); }
.dark-mode .file-card__btn { background: var(--app-form-tile); color: var(--app-text-muted); }
.dark-mode .rv-datepicker__trigger { background: var(--app-field); border-color: var(--app-field-border); }
.dark-mode .rv-datepicker__text { color: var(--app-text); }
.dark-mode .copy-btn { background: var(--app-accent-soft); border-color: var(--app-accent); }
.dark-mode .form-column:first-child { border-color: var(--app-border); }
</style>

<style>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .v-picker__body {
  background: var(--app-card) !important;
}

.dark-mode .v-date-picker-header {
  background: var(--app-card) !important;
}

.dark-mode .v-date-picker-header__value button {
  color: var(--app-text) !important;
}

.dark-mode .v-date-picker-header .v-btn {
  color: var(--app-text-muted) !important;
}

.dark-mode .v-date-picker-header .v-btn:hover {
  background: var(--app-form-tile-hover) !important;
}

.dark-mode .v-date-picker-table thead th {
  color: var(--app-text-faint) !important;
}

.dark-mode .v-date-picker-table .v-btn {
  color: var(--app-text) !important;
}

.dark-mode .v-date-picker-table .v-btn:hover {
  background: var(--app-accent-soft) !important;
}

.dark-mode .v-date-picker-table .v-btn--disabled {
  color: var(--app-text-faint) !important;
}

.dark-mode .v-picker__actions {
  background: var(--app-form-tile) !important;
  border-top: 1px solid var(--app-border) !important;
}

/* >>> end auto-dark <<< */

/* Date picker popup (unscoped — renders outside component) */
.v-picker {
  border-radius: 14px !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
  border: none !important;
  overflow: hidden;
  font-family: 'Lato', sans-serif !important;
}

.v-picker .v-picker__body {
  border: none !important;
}

/* The unscoped `.v-menu__content …` block that used to sit here is gone.
   It was global — unscoped CSS is injected once and never removed, so a rule
   written for THIS page's dropdown repainted every menu in the app (with
   !important, and with hard-coded light hex) for the rest of the session. That
   is what made the same v-select look different depending on which page you had
   visited. Menus are defined ONCE, in tokens, in src/plugins/theme-glass.css §3
   — panel, list, item radius, hover, active, typography and the state overlay.
   A page that genuinely needs its own menu styling should give that v-menu a
   `content-class` and key off it, the way .bdt-menu and .tb-view-menu do. */

.v-picker__body {
  background: #fff !important;
}

.v-date-picker-header {
  padding: 12px 16px 8px !important;
  background: #fff !important;
}

.v-date-picker-header__value button {
  font-family: 'Lato', sans-serif !important;
  font-weight: 700 !important;
  font-size: 0.95rem !important;
  color: #1e293b !important;
}

.v-date-picker-header .v-btn {
  color: #64748b !important;
}

.v-date-picker-header .v-btn:hover {
  background: #f1f5f9 !important;
}

.v-date-picker-table thead th {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  color: #94a3b8 !important;
  padding: 8px 0 !important;
}

.v-date-picker-table .v-btn {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.82rem !important;
  font-weight: 500 !important;
  color: #334155 !important;
}

.v-date-picker-table .v-btn:hover {
  background: #f0f9ff !important;
}

.v-date-picker-table .v-btn--active {
  background: #0ea5e9 !important;
  color: #fff !important;
  font-weight: 700 !important;
}

.v-date-picker-table .v-btn--active:hover {
  background: #0284c7 !important;
}

.v-date-picker-table .v-btn--outlined {
  border-color: #0ea5e9 !important;
  color: #0ea5e9 !important;
}

.v-date-picker-table .v-btn--disabled {
  color: #cbd5e1 !important;
}

.v-picker__actions {
  padding: 8px 16px 14px !important;
  background: #fff !important;
  border-top: 1px solid #f1f5f9 !important;
}

.v-picker__actions .v-btn {
  font-family: 'Lato', sans-serif !important;
  font-weight: 600 !important;
  font-size: 0.82rem !important;
  letter-spacing: 0.3px !important;
  text-transform: none !important;
  border-radius: 8px !important;
  padding: 0 16px !important;
}

.v-date-picker-years li,
.v-date-picker-months .v-btn {
  font-family: 'Lato', sans-serif !important;
}
</style>
